import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearTokens } from '../lib/auth';
import { useAuth } from '../lib/AuthContext';

export default function AuthLogout() {
  const navigate = useNavigate();
  const auth = useAuth();

  useEffect(() => {
    clearTokens();
    auth.refresh();
    navigate('/', { replace: true });
  }, [auth, navigate]);

  return <div className="min-h-screen grid place-items-center text-[var(--text-secondary)]">Signed out.</div>;
}
